import React from "react";

/**
 * Hype Hafen Logo – renders the official uploaded brand asset directly.
 * Image is a transparent PNG, width auto-scales to keep aspect ratio.
 */
export const HypeHafenLogo = ({ height = 64, className = "" }) => {
  return (
    <div
      className={`shrink-0 inline-flex items-center ${className}`}
      style={{ height }}
      data-testid="brand-logo"
      aria-label="Hype Hafen – Social Media Agentur"
    >
      <img
        src="/brand/hype-hafen-logo.png"
        alt="Hype Hafen – Social Media Agentur"
        style={{ height: "100%", width: "auto" }}
        className="object-contain select-none"
        draggable={false}
      />
    </div>
  );
};

export default HypeHafenLogo;
